import { Model } from '@/models/Model';
export class UserPeriod extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'UserPeriod';
        this.$endpoint = '/users/{id}/relationships/periods';
        this.$fillable = [];
    }
    user(user) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/periods`;
        return this;
    }
    userPeek(user) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/periods/peek`;
        return this;
    }
    setIdAttribute(id) {
        this.$endpoint = `/users/${this.user}/relationships/periods`;
        return id;
    }
    resolvePrimaryKey() {
        return '';
    }
    updatePeriodLevel(user, attributes) {
        const endpoint = `/users/${user}/relationships/period-level`;
        return this.request('put', endpoint, this.getPayload(attributes));
    }
}
